export enum ModelEnum {
  BankAccount = 'bankAccount',
  Payment = 'payment',
  Bill = 'bill',
  Organization = 'organization',
  PaymentRequest = 'paymentRequest',
  OrganizationUltimateBeneficialOwner = 'OrganizationUltimateBeneficialOwner',
  taxPayerInfo = 'TaxpayerInfo',
  DomesticWireAccount = 'DomesticWireAccount'
}
